import { useEffect, useRef, useState } from "react";
import { BarChart } from "chartist";
import "chartist/dist/index.css";
import "./MyVerticalBarChart.css";
import MyLegend from "./MyLegend";

export default function MyVerticalBarChart({
  data = { labels: [], series: [] },
  height = 300,
  stackBars = false,
  rotateLabels = false,
}) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: "",
  });

  useEffect(() => {
    // const data = {
    //   labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    //   series: [[5, 2, 8, 3, 7]],
    // };

    const options = {
      height: height - (data.series && data.series.length > 0 ? 10 : 0), // Leave space for legend if series exist
      axisY: {
        onlyInteger: true,
      },
      chartPadding: {
        top: 20,
        right: 10,
        bottom: rotateLabels === true ? 70 : 10,
        left: 10,
      },
      stackBars: stackBars,
    };

    chartInstance.current?.detach();


    chartInstance.current = new BarChart(chartRef.current, data, options);
    const handlers = [];

    if (!data.series || data.series.length === 0) {
      return;
    }

    chartInstance.current.on("draw", (ctx) => {
      if (rotateLabels) {
        if (ctx.type === "label" && ctx.axis?.units?.pos === "x") {
          console.log("Rotating label:", ctx.text);
          ctx.element.attr({
            x: ctx.x - 10,
            y: ctx.y + 25,
            transform: `rotate(-45 ${ctx.x - 10} ${ctx.y + 20})`,
            "text-anchor": "end",
          });
        }
      }

      if (ctx.type !== "bar") return;

      const node = ctx.element?._node;
      if (!node) return;

      const seriesName =
        ctx.series?.name || `Series ${Number(ctx.seriesIndex ?? 0) + 1}`;

      const value =
        ctx.value?.y ??
        ctx.value?.x ??
        (typeof ctx.value === "number" ? ctx.value : "");

      const onMove = (event) => {
        const containerRect = chartRef.current.getBoundingClientRect();

        setTooltip({
          visible: true,
          x: event.clientX - containerRect.left + 10,
          y: event.clientY - containerRect.top - 10,
          text: `${seriesName}: ${value}`,
        });
      };

      const onLeave = () => {
        setTooltip((t) => ({ ...t, visible: false }));
      };

      node.style.cursor = "pointer";
      node.addEventListener("mousemove", onMove);
      node.addEventListener("mouseleave", onLeave);

      handlers.push({ node, onMove, onLeave });
    });

    return () => {
      handlers.forEach(({ node, onMove, onLeave }) => {
        node.removeEventListener("mousemove", onMove);
        node.removeEventListener("mouseleave", onLeave);
      });
      chartInstance.current?.detach();
    };
  }, [data, height]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <div ref={chartRef} />
      {data.series && <MyLegend series={data.series} />}

      {tooltip.visible && (
        <div
          style={{
            position: "absolute",
            left: tooltip.x,
            top: tooltip.y,
            pointerEvents: "none",
            background: "#222",
            color: "#fff",
            padding: "6px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 10,
          }}
        >
          {tooltip.text}
        </div>
      )}
    </div>
  );
}
